
function spacing(options) {
  switch (options.size) {
    case 'fon':
      return [30, 15, 0, 15];
    case 'soc':
      return [10, 10, 10, 10];
    case 'appfeed':
      return [3, 0, 3, 0];
  }

  const left = options.type === 'scatter' ? 1 : 0;
  return [0, 0, 0, 0];
}

export default spacing;



// WEBPACK FOOTER //
// ./src/chart/outer/spacing.js